import { render, staticRenderFns } from "./base-loading.vue?vue&type=template&id=09974083&"
import script from "./base-loading.vue?vue&type=script&lang=js&"
export * from "./base-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports